const translations = {
  en: {
    DESCRIPTION: 'Description',
    INSTALL: 'Install',
    FEATURES: 'Features',
    PARAMETERS: 'Parameters',
    NAME: 'Name',
    TYPE: 'Type',
    RETURNS: 'Returns',
    USAGE: 'Usage',
    DEMO: 'Demo',
    USE_CASES: 'Use Cases',
  },
  sr: {
    DESCRIPTION: 'Opis',
    INSTALL: 'Instalacija',
    FEATURES: 'Karakteristike',
    PARAMETERS: 'Parametri',
    NAME: 'Ime',
    TYPE: 'Tip',
    RETURNS: 'Vraća',
    USAGE: 'Upotreba',
    DEMO: 'Demo',
    USE_CASES: 'Slučajevi Upotrebe',
  },
};

export const translate = (key, language) => {
  return translations[language][key] || key;
};
